<template>
  <div class="home">
    <v-container>
      <v-row>
        <img src="../assets/smart-farming.jpg" style="width: 100%; height: auto;" />
        <!-- <div class="ontop">
            <span class="headline blue--text">SMART FARMING</span> <br />
            Smart farming should work for you <br />
            start where you can have the most <br />
            impact <span class=primary--text>Feed Management</span>
        </div> -->
      </v-row>
      <v-row>
        <v-col cols="12" sm="5">
          <p class="display-3 ma-2 mt-8 text-center primary--text">Feeding Management System</p>
        </v-col>
        <v-col sm="2" class="d-flex my-auto" v-if="$vuetify.breakpoint.smAndUp">
        </v-col>
        <v-col sm="4" class="d-flex my-auto justify-center">
            <v-btn rounded color="primary" height="50px" dark class="d-flex my-3 py-auto" @click=gotoSignup>
              <v-icon class="mx-4">mdi-tractor</v-icon>
              Test Drive Now...
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="2" v-if="$vuetify.breakpoint.smAndUp"></v-col>
        <v-col cols="12" sm="5">
          <img src="../assets/better-profit.png" style="max-width: 90%; height: auto;" class="d-flex my-7 mx-auto" />
        </v-col>
        <v-col cols="12" sm="5">
          <v-card flat class="my-8 d-flex justify-center">
            <p class="display-3 blue--text font-weight-bold">Simple</p>
          </v-card>
          <v-card flat class="my-8 d-flex justify-center">
            <v-card-title class="display-3 d-flex green--text font-weight-bold">Accurate</v-card-title>
          </v-card>
          <v-card flat class="my-8 d-flex justify-center">
            <v-card-title class="display-3 d-flex purple--text font-weight-bold">Insight</v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="d-flex my-auto">
          <img alt="v-Feed" src="../assets/tablet-web.png" style="width: 90%; height: auto;"
              class="d-flex mx-auto " />
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="12" sm="5" md="5">
          <ul style="line-height: 200%; color: blue" class="display-1"
            :class="{'ma-3' :$vuetify.breakpoint.smAndUp, 'headline': $vuetify.breakpoint.mdAndDown}">
          <li class="ms-10 green--text">Plan feed schedule</li>
          <li class="ms-1 blue--text">Optimize daily wagons</li>
          <li class="ms-10 gray--text">Collect actual data</li>
          <li class="ms-1 purple--text">Simple analysis</li>
          <li class="ms-10 orange--text">Plan your ordering</li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <p class="display-1 ma-2 mt-8 text-justify primary--text">
            A <span class="purple--text font-wight-medium">tablet app</span>, connected to your wagon's scale with
            a companion <span class="orange--text font-wight-medium">web</span> based planning and reporting
            <span class="orange--text font-wight-medium">app</span>.  that combined to give you
            a <span class="blue--text font-wight-medium">simple</span> and
            <span class="green--text font-wight-medium">accurate</span> system to manage your feed schedule, dosage, and mixing.
          </p>
        </v-col>
        <v-col cols="12" sm="5" class="d-block my-auto">

          <v-btn rounded color="orange" dark height="50px" class="d-flex my-10 py-auto mx-auto px-8" @click=gotoSignup>
            <v-icon class="mx-4">mdi-hand-pointing-right</v-icon>
            Try for Free...
          </v-btn>
          <p class="d-flex">
          <v-btn rounded color="green" dark height="50px" class="my-10 py-auto mx-auto justify-center" to="compare">
            <v-icon class="mx-4">mdi-credit-card-outline</v-icon>
            Pricing &#38; Options
          </v-btn>
          </p>
        </v-col>
      </v-row>
    </v-container>
    <!-- <img alt="v-feed logo" src="../assets/logo.png"> -->

  </div>
</template>

<script>
// import lineAnimate from '../components/lineAnimate';
// @ is an alias to /src

export default {
  name: 'home',
  components: {
    // lineAnimate
  },
  methods: {
    gotoSignup() {
      this.$router.replace({name: 'signup'});
    }
  }

}
</script>
<style>
  @import url('https://fonts.googleapis.com/css?family=Dosis&display=swap');
  body {
    font-family: 'Dosis';  /* sans-serif */
    font-weight: 700;
  }
  .ontop{
    position: absolute;
    top: 80px;
    right: 26px;

   padding: 12px;
   background-color: white;
   border: none;
  }
</style>